<template>
	<div class="container pb_0">
		<div class="main">
			<p class="text_t type1">{{ $t('rtr_personal-asset-wallet.text1') }}</p>
			<p class="text_n">
				{{ $t('rtr_personal-asset-wallet.text2') }}<br />
				{{ $t('rtr_personal-asset-wallet.text3') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.asset_send') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="divide_box"></div>
		<div class="main type2">
			<p class="text_t type2 mb_30 pt_100">
				{{ $t('rtr_personal-asset-wallet.text4') }}<br />
				{{ $t('rtr_personal-asset-wallet.text5') }}
			</p>
			<p class="text_n">
				{{ $t('rtr_personal-asset-wallet.text6') }}<br />
				{{ $t('rtr_personal-asset-wallet.text7') }}
			</p>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box border_r_16 mb_16">
					<div class="bg_text_area left">
						<p class="text_t fc_white">
							{{ $t('rtr_personal-asset-wallet.text8') }}<br />
							{{ $t('rtr_personal-asset-wallet.text9') }}
						</p>
						<p class="text_n fc_white">
							{{ $t('rtr_personal-asset-wallet.text10') }}<br />
							{{ $t('rtr_personal-asset-wallet.text11') }}
						</p>
					</div>
				</div>

				<div class="bg_box">
					<div class="bg_text_area right tac">
						<p class="text_t">
							{{ $t('rtr_personal-asset-wallet.text12') }}<br />
							{{ $t('rtr_personal-asset-wallet.text13') }}
						</p>
						<p class="text_n">
							{{ $t('rtr_personal-asset-wallet.text14') }}<br />
							{{ $t('rtr_personal-asset-wallet.text15') }}<br />
							{{ $t('rtr_personal-asset-wallet.text16') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Wallet',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
